import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.978 20.886v10.025a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001Zm-12 0v10.025a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001Zm24 0v10.025a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001ZM44 39.896l.002 1.19a3 3 0 0 1-2.716 2.993 182.012 182.012 0 0 1-34.569 0 3 3 0 0 1-2.715-2.981L4 39.908A3 3 0 0 1 6.995 36.9H41a3 3 0 0 1 3 2.994Zm.006-27.518v.034a2.498 2.498 0 0 1-2.498 2.498 17725.251 17725.251 0 0 0-34.992 0 2.508 2.508 0 0 1-2.51-2.506v-.045a3 3 0 0 1 2.098-2.861l16.989-5.359a3 3 0 0 1 1.807 0l17.01 5.378a3 3 0 0 1 2.096 2.86Z",
    fill: "currentColor"
  }));
};

var SvgCompany = styled(SvgComponent).withConfig({
  displayName: "Company__SvgCompany",
  componentId: "sc-1fmchy8-0"
})(["", " ", ""], size, color);
export default SvgCompany;